import { API, API_BASEURL, buildUrl } from "../../../../config";
import { fetcherUploader } from "../../../../utils";

/**
 * CLRDC-2234: HTTP wrapper around the credit-report AI endpoint.
 *
 * Centralised here (instead of inlined in the popup) so future
 * entry-points (e.g. a "Re-run analysis" action, or a lead-creation
 * flow) can reuse the exact same payload shape.
 */
export interface ExtractedTradeline {
    report_order: number;
    creditor: string;
    type: string;
    classification:
        | "positive"
        | "negative"
        | "neutral"
        | "collections"
        | "open";
    status: string;
    balance: number | null;
    disputed: boolean;
    remarks: string | null;
}

export interface ExtractedCreditReportData {
    eq: number | null;
    tu: number | null;
    ex: number | null;
    accounts_positive: number | null;
    accounts_negative: number | null;
    num_collections: number | null;
    num_disputes: number | null;
    num_inquiries: number | null;
    num_public_records: number | null;
    num_open_accounts: number | null;
    repositions: number | null;
    mix_social_itin: boolean | null;
    bk_type: string | null;
    tradelines: ExtractedTradeline[];
    notes: string | null;
}

export class CreditReportService {
    async analyzePdf(
        token: string,
        pdfFile: File,
    ): Promise<ExtractedCreditReportData> {
        const url = buildUrl(API.ANALYZE_CREDIT_REPORT, {}, API_BASEURL);
        const formData = new FormData();
        formData.append("file", pdfFile);

        const [result, error] = await fetcherUploader(url, token, formData);
        if (error) {
            const message =
                error?.error?.message ||
                error?.message ||
                "Failed to analyze credit report";
            throw new Error(message);
        }
        return result?.data as ExtractedCreditReportData;
    }
}